'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _LinkContainer = require('react-router-bootstrap/lib/LinkContainer');

var _LinkContainer2 = _interopRequireDefault(_LinkContainer);

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

var _NavItem = require('react-bootstrap/lib/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _Collapse = require('react-bootstrap/lib/Collapse');

var _Collapse2 = _interopRequireDefault(_Collapse);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _sidemenu = require('redux/modules/sidemenu');

var menuActions = _interopRequireWildcard(_sidemenu);

var _reactI18next = require('react-i18next');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _auth2 = require('selectors/auth');

var _utils = require('helpers/utils');

var _permissions = require('helpers/permissions');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SideMenu.scss');

var cn = _bind2.default.bind(styles);
var logoImg = require('./logo.png');

var SideMenu = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    hiddenSections: state.sidemenu.hiddenSections,
    permissions: (0, _auth2.getPermissions)(state),
    playlistKey: (0, _get4.default)(state, 'playlist.playlistActionData.key'),
    user: (0, _auth2.getUser)(state),
    visible: state.sidemenu.visible
  };
}, (0, _extends3.default)({}, authActions, menuActions), null, { pure: false }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SideMenu, _Component);

  function SideMenu() {
    (0, _classCallCheck3.default)(this, SideMenu);
    return (0, _possibleConstructorReturn3.default)(this, (SideMenu.__proto__ || (0, _getPrototypeOf2.default)(SideMenu)).apply(this, arguments));
  }

  (0, _createClass3.default)(SideMenu, [{
    key: 'logout',
    value: function logout() {
      this.props.logout();
    }
  }, {
    key: 'toggleSection',
    value: function toggleSection(e, section) {
      (0, _utils.stopEvent)(e);
      var toggleSection = this.props.toggleSection;

      toggleSection(section);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          user = _props.user,
          t = _props.t,
          show = _props.show,
          hide = _props.hide,
          visible = _props.visible,
          hiddenSections = _props.hiddenSections,
          playlistKey = _props.playlistKey,
          permissions = _props.permissions;

      var maskClass = cn('mask', { visible: visible });
      var hamburgerClass = cn('hamburger', { visible: !visible });
      var sideMenuClass = cn('sideMenu', { visible: visible });
      var getExpanderClass = function getExpanderClass(section) {
        return (0, _bind2.default)(styles.expander, hiddenSections[section] ? 'icon-chevron-thin-down' : 'icon-chevron-thin-up');
      };
      var isHasProjectsAccess = (0, _permissions.hasProjectsAccess)(user);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { className: maskClass, onClick: hide }),
        _react2.default.createElement(
          'button',
          { className: hamburgerClass, onClick: show },
          _react2.default.createElement('i', { className: 'icon-menu' })
        ),
        _react2.default.createElement(
          'div',
          { className: sideMenuClass, onClick: hide },
          user ? _react2.default.createElement(
            'span',
            { className: styles.logo },
            _react2.default.createElement('img', { src: logoImg, alt: '' })
          ) : _react2.default.createElement(
            _Link2.default,
            { to: '/', className: styles.logo },
            _react2.default.createElement('img', { src: logoImg, alt: '' })
          ),
          user && _react2.default.createElement(
            'div',
            { className: styles.username, onClick: this.logout },
            _react2.default.createElement(
              'div',
              null,
              user.fullName
            ),
            _react2.default.createElement(
              'div',
              null,
              t('Log out'),
              _react2.default.createElement('i', { className: 'icon-exit margin-left-5' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.section, onClick: function onClick(e) {
                return _this2.toggleSection(e, 'main');
              } },
            t('Main'),
            _react2.default.createElement('i', { className: getExpanderClass('main') })
          ),
          _react2.default.createElement(
            _Collapse2.default,
            { 'in': !hiddenSections.main },
            _react2.default.createElement(
              'ul',
              { className: styles.links },
              !user && _react2.default.createElement(
                _LinkContainer2.default,
                { to: '/login' },
                _react2.default.createElement(
                  _NavItem2.default,
                  null,
                  _react2.default.createElement('i', { className: 'icon-user' }),
                  t('Login')
                )
              ),
              !user && playlistKey && _react2.default.createElement(
                _LinkContainer2.default,
                { to: '/playlists/fromkey/' + playlistKey },
                _react2.default.createElement(
                  _NavItem2.default,
                  null,
                  _react2.default.createElement('i', { className: 'icon-music' }),
                  t('Playlist')
                )
              ),
              !user && _react2.default.createElement(
                _LinkContainer2.default,
                { to: '/contact-us' },
                _react2.default.createElement(
                  _NavItem2.default,
                  null,
                  _react2.default.createElement('i', { className: 'icon-newsletter' }),
                  t('Contact us')
                )
              ),
              user && _react2.default.createElement(
                _LinkContainer2.default,
                { to: '/account' },
                _react2.default.createElement(
                  _NavItem2.default,
                  null,
                  _react2.default.createElement('i', { className: 'icon-user' }),
                  t('Account')
                )
              ),
              (0, _permissions.hasContactsAccess)(user) && _react2.default.createElement(
                _LinkContainer2.default,
                { to: '/contacts' },
                _react2.default.createElement(
                  _NavItem2.default,
                  null,
                  _react2.default.createElement('i', { className: 'icon-users' }),
                  t('Contacts')
                )
              ),
              _react2.default.createElement(
                _LinkContainer2.default,
                { to: '/info' },
                _react2.default.createElement(
                  _NavItem2.default,
                  null,
                  _react2.default.createElement('i', { className: 'icon-info' }),
                  t('Information')
                )
              )
            )
          ),
          user && _react2.default.createElement(
            'div',
            null,
            (isHasProjectsAccess || permissions.statsEnable) && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: styles.section, onClick: function onClick(e) {
                    return _this2.toggleSection(e, 'projects');
                  } },
                t('Projects'),
                _react2.default.createElement('i', { className: getExpanderClass('projects') })
              ),
              _react2.default.createElement(
                _Collapse2.default,
                { 'in': !hiddenSections.projects },
                _react2.default.createElement(
                  'ul',
                  { className: styles.links },
                  isHasProjectsAccess && _react2.default.createElement(
                    _LinkContainer2.default,
                    { to: '/projects/new' },
                    _react2.default.createElement(
                      _NavItem2.default,
                      null,
                      _react2.default.createElement('i', { className: 'icon-add' }),
                      t('New')
                    )
                  ),
                  isHasProjectsAccess && _react2.default.createElement(
                    _LinkContainer2.default,
                    { to: '/projects' },
                    _react2.default.createElement(
                      _NavItem2.default,
                      null,
                      _react2.default.createElement('i', { className: 'icon-list' }),
                      t('Project List')
                    )
                  ),
                  permissions.statsEnable && _react2.default.createElement(
                    _LinkContainer2.default,
                    { to: '/statistics' },
                    _react2.default.createElement(
                      _NavItem2.default,
                      null,
                      _react2.default.createElement('i', { className: 'icon-stats-bars' }),
                      t('Statistics')
                    )
                  ),
                  isHasProjectsAccess && permissions.quickSendAccess && _react2.default.createElement(
                    _LinkContainer2.default,
                    { to: '/quick-send' },
                    _react2.default.createElement(
                      _NavItem2.default,
                      null,
                      _react2.default.createElement('i', { className: 'icon-paper-plane' }),
                      t('Quick Send')
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.section, onClick: function onClick(e) {
                  return _this2.toggleSection(e, 'content');
                } },
              t('Content'),
              _react2.default.createElement('i', { className: getExpanderClass('content') })
            ),
            _react2.default.createElement(
              _Collapse2.default,
              { 'in': !hiddenSections.content },
              _react2.default.createElement(
                'ul',
                { className: styles.links },
                _react2.default.createElement(
                  _LinkContainer2.default,
                  { to: '/playlists' },
                  _react2.default.createElement(
                    _NavItem2.default,
                    null,
                    _react2.default.createElement('i', { className: 'icon-music' }),
                    t('My Content')
                  )
                ),
                _react2.default.createElement(
                  _LinkContainer2.default,
                  { to: '/my-playlists' },
                  _react2.default.createElement(
                    _NavItem2.default,
                    null,
                    _react2.default.createElement('i', { className: 'icon-playlist' }),
                    t('My Playlists')
                  )
                )
              )
            ),
            permissions.admEnable && _react2.default.createElement(
              'ul',
              { className: styles.links },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: _config2.default.app.productionUrl + '/advanced/' },
                  _react2.default.createElement('i', { className: 'icon-admin' }),
                  t('Admin')
                )
              )
            )
          )
        )
      );
    }
  }]);
  return SideMenu;
}(_react.Component), _class3.propTypes = {
  hiddenSections: _propTypes2.default.object,
  hide: _propTypes2.default.func,
  logout: _propTypes2.default.func,
  permissions: _propTypes2.default.object,
  playlistKey: _propTypes2.default.string,
  show: _propTypes2.default.func,
  t: _propTypes2.default.func,
  toggleSection: _propTypes2.default.func,
  user: _propTypes2.default.object,
  visible: _propTypes2.default.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'logout', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'logout'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = SideMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SideMenu/SideMenu.js
// module id = 2097
// module chunks = 1